import React from 'react';
import { useSelector } from 'react-redux';

import ContentViewComponent from '#app/Component/ContentViewComponent';
import IconAction from '#app/Component/IconAction';
import TableComponent from '#app/Component/TableComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { ReapproStateTranslation } from '#app/typings/reappro';

function ListReappro() {
  const authenticationReducer = useSelector((state) => state.AuthenticationReducer);

  // List Deposits
  const columns = [
    {
      name: 'id',
      label: 'Référence',
      options: { filter: true, sort: true },
    },
    {
      name: 'deposit',
      label: 'Dépôt source',
      options: { filter: true, sort: true },
    },
    {
      name: 'fromDeposit',
      label: 'Dépôt demandeur',
      options: { filter: true, sort: true },
    },
    {
      name: 'createdAt',
      label: 'Date création',
      options: { filter: true, sort: true },
    },
    {
      name: 'state',
      label: 'Statut',
      options: { filter: true, sort: true },
    },
    {
      name: 'shop',
      label: 'Boutique',
      options: { filter: true, sort: true },
    },
    {
      name: 'action',
      label: 'Action',
      options: { filter: false, sort: false },
    },
  ];

  const getAction = (row) => (
    <IconAction title="Modifier" icon="edit" to={getRoutePathname('shop_reappro_reception', { reapproId: row.id })} />
  );

  return (
    <ContentViewComponent breadcrumbs={{ title: 'Liste des réapprovisionnements', context: 'Gestion boutique' }}>
      <TableComponent
        id={'api_shop_management_shop_list_reappro'}
        title={'Boutiques'}
        columns={columns}
        promiseData={(resolve) => {
          ApiHandler.get(
            { route: 'api_shop_reappro_list_reappro_by_shop', params: { shopId: authenticationReducer.shopSelected } },
            (response) => {
              const data = response.data;
              for (const index in data) {
                data[index].action = getAction(data[index]);
                data[index].createdAt = data[index].createdAt ? data[index].createdAt : '-';
                data[index].deposit = data[index].deposit ? data[index].deposit : '-';
                data[index].fromDeposit = data[index].fromDeposit ? data[index].fromDeposit : '-';
                data[index].state = ReapproStateTranslation[data[index].state];
                data[index].shop = data[index].shop ? data[index].shop : '-';
              }
              resolve(data);
            },
          );
        }}
      />
      <br />
      <br />
    </ContentViewComponent>
  );
}

export default ListReappro;
